import { useAuth0 } from "@auth0/auth0-react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField } from "components";
import InfoTooltip from "components/InfoTooltip";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { useSearch } from "hook";
import PastoralService from "Lib/API/PastoralApi";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import MyButton from "../../../components/MyButton";
import NewTaskSuccess from "./NewTaskSuccess";
import "./styles.scss";

const colourStyles = {
	control: (styles) => ({
		...styles,
		...selectControlStyles,
	}),
	menuList: (styles) => ({
    ...styles,
		maxHeight: "150px",
	}),
};

const selectControlStyles = {
	backgroundColor: "#F3F6F9",
	borderColor: "#F3F6F9",
	color: "#3F4254",
	transition: "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
	paddingTop: "6px",
	paddingBottom: "6px",
	cursor: "pointer",
};
function convertUTCToLocalDate(date) {
	if (!date) {
		return date;
	}
	date = new Date(date);
	date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	return date;
}



const formatOptionLabel = ({ label, _id }) => {
	return (
		<div className="dropdown-container" key={_id}>
			<div className="icon-name-container d-flex align-items-center justify-content-start">
				<div className="name-container" style={{ marginInlineStart: 10 }}>
					<div>{label}</div>
				</div>
			</div>
		</div>
	);
};

const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<BottomArrowSvg label="Emoji" />
		</components.DropdownIndicator>
	);
};

const NewTask = ({ closeModal,handleClose,setCallTasksAgain,setSuccessFullTask,successFullTask, ...props }) => {
	const { getAccessTokenSilently } = useAuth0();
	const { searchAction } = useSearch({ action: setSearch });
	const [search, setSearch] = useState("");
	const [userData, setUserData] = useState(false);
	const [responseData, setResponseData] = useState(false);
	const [createTaskLoading, setCreateTaskLoading] = useState(false);
	const [getEventUsersLoading, setGetEventUsersLoading] = useState(false);
	const [getMembersLoading, setGetMembersLoading] = useState(false);

	const dateMask = maskDate();
	const placeholderFormat = getDateFormat();
	const dateFormat = getDateFormatForDatePicket();
	const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");

	function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes())
    );
    formik.setFieldValue(name, date);
    return date;
  }

	const fetchUsersApi = async (page) => {
		setGetEventUsersLoading(true);
		const token = await getAccessTokenSilently();
		PastoralService.getEventUsers({ token, page })
			.then((res) => {
				if (res) {
					setUserData(res?.users);
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setGetEventUsersLoading(false);
			});
	};

	const fetchMyAPI = async (page) => {
		setGetMembersLoading(true);
		const token = await getAccessTokenSilently();
		PastoralService.getMembers({ token, page })
			.then((res) => {
				if (res) {
					setResponseData(res?.contacts);
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setGetMembersLoading(false);
			});
	};

	React.useEffect(() => {
		fetchUsersApi(1);
		fetchMyAPI(1);
	}, []);

	const options1 =
		userData &&
		userData?.map((item) => {
			return {
				label: `${item?.type} ${item?.fullName ? "- " + item?.fullName : ""}`,
				value: item?.id,
			};
		});

	const options2 =
		responseData &&
		responseData?.map((item) => {
			return {
				label: item?.fullName,
				value: item?.id,
			};
		});

	const options3 = [
		{
			value: "1",
			label: "SMS",
		},
		{
			value: "2",
			label: "EMAIL",
		},
		{
			value: "3",
			label: "CALL",
		},
		{
			value: "4",
			label: "Home VISIT",
		},
		{
			value: "5",
			label: "Hospital VISIT",
		},
		{
			value: "10",
			label: "Other",
		},
	];

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			assignTo: { id: "", name: "" },
			contactWith: { id: "", name: "" },
			actionTypeId: { id: "", name: "" },
			taskDescription: "",
			taskDate: "",
		},

		// validationSchema: AddNewAccountSchema,
	});

	const validateSubmit = () => {
		if (!formik?.values?.taskDescription) {
			return toastr.info("Task Description is required");
		}
		if (!formik?.values?.taskDate) {
			return toastr.info("Task Date is required");
		}
		if (!formik?.values?.assignTo?.id) {
			return toastr.info("Assign To is required");
		}
		if (!formik?.values?.actionType?.id) {
			return toastr.info("Action Type is required");
		}

		onSubmit();
	};

	const delay = (ms) => new Promise((resolve) => setTimeout(() => resolve(), ms));

	const onSubmit = async (values) => {
		setCreateTaskLoading(true);
		await delay(2000);
		const token = await getAccessTokenSilently();
		const input = {
			date: formik.values.taskDate,
			clergyType: formik.values?.assignTo?.id.toString(),
			description: formik.values?.taskDescription,
			actionTypeId: formik.values?.actionType?.id.toString(),
			ContactWithId: formik.values?.contactWith.id ? formik.values?.contactWith.id.toString() : undefined,
		};
		await PastoralService.createTask({ data: input, token })
			.then((res) => {
				// toastr.success("Task created successfully.")
				// closeModal(false);
				setSuccessFullTask(true);
				setCallTasksAgain((prevState) => !prevState);
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setCreateTaskLoading(false);
			});
	};

	return (
		<div className="add-new-task-drawer p-14">
			{successFullTask !== true ? (
				<>
					<h1 className="NewEvent-heading text-center">New Task</h1>
					<div className="addEvent-form d-flex flex-column justify-content-between h-100">
						<>
							<div className="row mt-10">
								<div className="form-group col-12 col-md-6">
									<InputField
										{...{
											...formik,
											mandatory: true,
											title: "Task Description",
											name: "taskDescription",
											placeholder: "Please Add Description",
											value: formik.values?.taskDescription,
										}}
									/>
								</div>
								<div className="form-group pastoral-date-picker col-12 col-md-6">
									<LabelField title={"Task Date"} mandatory={true} />
									<DatePicker
										isClearable={formik.values?.taskDate || false}
										showIcon
										placeholderText={placeholderFormat}
										dateFormat={dateFormat}
										selected={
											formik.values?.taskDate && 
											convertUTCToLocalDate(formik.values?.taskDate)
										}
										onChange={(date) => {
											formik.setFieldValue("taskDate", date);
											convertLocalToUTCDate(date, "taskDate");
										}}
										minDate={new Date()}
										showYearDropdown
										customInput={
											<MaskedInput pipe={autoCorrectedDatePipe} mask={dateMask} keepCharPositions={true} guide={true} />
										}
									/>
								</div>
								<div className="form-group assignto-field col-12 col-md-6">
									<div className="d-flex align-items-center">
										<LabelField title={"Assign To"} mandatory={true} />
										<InfoTooltip text="The staff member/user responsible for completing this task." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-2px)' }} />
									</div>
									<Select
										{...{
											formik,
											name: `assignTo`,
											checkValidation: false,
										}}
										classNamePrefix="react-select"
										formatOptionLabel={formatOptionLabel}
										options={options1}
										isLoading={getEventUsersLoading}
										styles={colourStyles}
										onChange={(value) => {
											formik.setFieldValue(`assignTo`, {
												id: value.value,
												name: value.label,
											});
										}}
										value={
											formik.values?.assignTo
												? {
														label: formik.values?.assignTo?.name,
														value: formik.values?.assignTo?.id,
												  }
												: ""
										}
										components={{ DropdownIndicator }}
									/>
								</div>
								<div className="form-group col-12 col-md-6">
									<div className="d-flex align-items-center">
										<LabelField title={"Contact With"} />
										<InfoTooltip text="Team members who should be notified of this task." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-2px)' }} />
									</div>
									<Select
										{...{
											formik,
											name: `contactWith`,
											mandatory: true,
											checkValidation: false,
										}}
										classNamePrefix="react-select"
										styles={colourStyles}
										formatOptionLabel={formatOptionLabel}
										options={options2}
										isLoading={getMembersLoading}
										onChange={(value) => {
											formik.setFieldValue(`contactWith`, {
												id: value.value,
												name: value.label,
											});
										}}
										value={{
											label: formik.values?.contactWith?.name,
											value: formik.values?.contactWith?.id,
										}}
										components={{ DropdownIndicator }}
									/>
								</div>
								<div className="form-group col-12 col-md-6">
									<LabelField title={"Action Type"} mandatory={true} />
									<Select
										{...{
											formik,
											name: `actionType`,
											mandatory: true,
											checkValidation: false,
										}}
										classNamePrefix="react-select"
										styles={colourStyles}
										formatOptionLabel={formatOptionLabel}
										options={options3}
										onChange={(value) => {
											formik.setFieldValue(`actionType`, {
												id: value.value,
												name: value.label,
											});
										}}
										value={{
											label: formik.values?.actionType?.name,
											value: formik.values?.actionType?.id,
										}}
										components={{ DropdownIndicator }}
									/>
								</div>
							</div>
							<div className="close-save-div d-flex justify-content-between my-10" style={{ gap: "20px" }}>
								<div className="saveBtn-drawer">
									<MyButton
										type={"secondary"}
										content={"Close"}
										onClick={() => {
											closeModal();
										}}
									/>
								</div>
								<div className="saveBtn-drawer">
									<MyButton
										type={"primary"}
										content={
											createTaskLoading ? (
												<div className="d-flex align-items-center justify-content-center">
													<CircularProgress
														size={20}
														style={{
															color: "#ffffff",
														}}
													/>
												</div>
											) : (
												"Save"
											)
										}
										onClick={() => {
											validateSubmit();
										}}
										disabled={createTaskLoading}
										variant="outlined"
									/>
								</div>
							</div>
						</>
					</div>
				</>
			) : createTaskLoading == true ? (
				<div className="w-100 h-100 d-flex justify-content-center align-items-center">
					<Loader />
				</div>
			) : (
				<NewTaskSuccess 
          closeModal={() => {
            handleClose();

          }}
        />
			)}
		</div>
	);
};
export default NewTask;
